import { useMutation, ApolloError } from '@apollo/client'

import { MUTATION_DELETE_COMMENT } from '@libs/apollo/mutations'

import { MutationDeleteCommentArgs } from '@types'

interface Data {
  deleteComment: boolean
}

export const useDeleteComment = (): {
  deleteComment: (id: string) => Promise<void>
  loading: boolean
  error: ApolloError | undefined
  data?: Data | null
} => {
  const [deleteComment, { loading, error, data, client }] = useMutation<Data, MutationDeleteCommentArgs>(
    MUTATION_DELETE_COMMENT,
    {
      notifyOnNetworkStatusChange: true,
    },
  )

  const _deleteComment = async (id: string): Promise<void> => {
    const { cache } = client

    const normalizedId = cache.identify({ id: id, __typename: 'Comment' })
    cache.evict({ id: normalizedId })
    cache.gc()

    await deleteComment({
      variables: { input: { commentId: id } },
    })
  }

  return { deleteComment: _deleteComment, loading, error, data }
}
